export default {
  faqsections (state) {
    return state.faqsections
  },
  selectedFaqsection (state) {
    return state.selectedFaqsection
  },
  getFaqsection: state => (faqsectionId) => {
    return state.faqsections.find(faqsection => faqsection.faqHeaderId === faqsectionId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/faqsections/getters.js